export default "__VITE_ASSET__BxFppvPd__"